import script from "./Docs.vue?vue&type=script&setup=true&lang=js"
export * from "./Docs.vue?vue&type=script&setup=true&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=fa8d26de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa8d26de"]])

export default __exports__